module.exports = __webpack_public_path__ + "static/media/bg-texture-1.9b8d8309.png";